import React from "react"
// import "./memberCSV.css"
import * as Moment from "moment"
import styled, { css } from "styled-components"
import * as _ from "lodash"
import { ReadStream } from "fs"

const MembersCsvWrapper = styled.div`
  display: block;
  flex-direction: column;
  padding: 0px;
  padding-right: 0px;
  width: 700px;
`

const MemberLineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* border-bottom: 2px dotted #aaa; */
  /* padding-bottom: 10px; */
  /* padding-top: 10px; */

  ${props =>
    props.pageBreak &&
    css`
      @media print {
        margin-top: 20px;
        page-break-before: always;
        break-before: always;
      }
    `}
`
const CsvHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 10px;
`

const ImageDiv = styled.div`
  img {
    width: 90px;
  }
`

const TitleWrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  vertical-align: bottom;

  h1 {
    color: #b00;
    margin: 0;
    margin-left: 10px;
    font-size: 1.4em;
    flex: 1 1 auto;
    align-self: flex-end;
    font-weight: 800;
  }

  h2 {
    color: #000;
    margin: 0;
    margin-left: 3px;
    font-size: 1.8em;
    flex: 1 1 auto;
    align-self: flex-end;
    font-weight: 800;
  }

  h3 {
    color: #888;
    margin: 0;
    margin-left: 10px;
    font-size: 0.8em;
    flex: 1 1 auto;
    align-self: flex-end;
  }
`

const MemberCsvTable = styled.table`
width: 98%;
margin-left: 20px;
  background: white;
  font-size: 0.8em;
  /* margin-top: 10px; */
  border-spacing: 0;

  page-break-before: always;

  @media print {
    page-break-inside: auto;
    break-inside: auto;
  }
  /* page-break-inside: avoid;
  break-inside: avoid; */
  /* .header th {
    text-align: left;
  }

  tr.header td {
    border-bottom: 2px solid black;
    font-weight: bold;
  } */
`

const MemberTr = styled.tr``
const RankImg = styled.img`
  width: 16px;
`

const MemberTd = styled.td`
  ${props =>
    props.width
      ? css`
          width: ${props.width};
        `
      : css`
          /* width: 10%; */
        `};
  background: white;
  margin: 0;
  padding: 0;
  padding-right: 10px;
  padding-bottom: 8px;
  vertical-align: middle;
  font-weight: bold;
  font-size: 1.3em;
      /* font-size: 18px; */

  @media print {
    page-break-inside: avoid;
    break-inside: avoid;
  }
`

const Box = styled.div`
  border: 1px solid #555;
  width: 16px;
  height: 16px;
`
const TestHeaderTr = styled.tr`
  font-weight: bold;
  font-size: 1.3em;
  /* font-size: 0.7em; */
  margin-top: 40px;
  /* padding-bottom: 25px; */
  color: #800;

 height: 30px;
 vertical-align: top;
`

const TestPointsTr = styled.tr``
const TestPointsTd = styled.td``
const TestPointsDiv = styled.div`
  /* min-height: 40px; */
`
const ImportSvgImg = styled.img`
  width: 100%;
`

const ImageFrame = styled.div`
  overflow: hidden;
  border-radius: 40px;
  width: 45px;
  height: 45px;
  img {
    margin-top: -8px;
    margin-left: -4px;
    width: 60px;
  }
`

const MemberTestResultSheet = props => {
  console.log("member CSV called!")
  let membersList = [...props.filteredMembers]
  let memberRanks = []

  const withLatestRank = membersList.map(member => {
    memberRanks = props.ranks.filter(rank => {
      return rank.MemberId == member.ID
    })

    const currentRank = memberRanks.length > 0 ? memberRanks[0] : null

    return {
      ...member,
      currentRank,
      currentRankImage: currentRank && currentRank.level ? "/" + currentRank.level.LevelImage : null
    }
  })

  // ,"currentRank.LevelId", "FirstName"

  const sortedMembersList = _.orderBy(
    withLatestRank,
    ["currentRank.RankDate", "currentRank.LevelId", "FirstName"],
    ["desc", "asc", "asc"]
  )

  const sprtedMemberListWithRankSeperator = sortedMembersList.reduce((all, member) => {
    member.prevRankWasDifferent =
      _.last(all) && _.last(all).currentRank && member.currentRank
        ? member.currentRank.LevelId != _.last(all).currentRank.LevelId
        : false

    return [...all, member]
  }, [])

  let memberCount = 17
  let newPage = false
  membersList = sprtedMemberListWithRankSeperator.map(member => {
    // Handle page break
    // memberCount++
    // newPage = false

    // // if (memberCount == 14 || member.prevRankWasDifferent) {
    // if (memberCount == 18) {
    //   newPage = true
    //   memberCount = 0
    // }

    const memberLine = member.currentRank ? (
      <MemberTr key={member.ID} prevRankWasDifferent={member.prevRankWasDifferent}>
        <MemberTd>
          <ImageFrame>
            <img src={member.ImageUrl} />
          </ImageFrame>
        </MemberTd>
        <MemberTd>
          {member.FirstName} {member.LastName}
        </MemberTd>
        {/* <MemberTd>
          {member.currentRank ? Moment(member.currentRank.RankDate).format("DD. MMMM YYYY") : "N/A"}
        </MemberTd> */}
        {/* <MemberTd>
          {member.currentRank ? Moment(member.currentRank.RankDate).fromNow() : "N/A"}
        </MemberTd> */}
        <MemberTd>{member.currentRank.level.LevelTitle}</MemberTd>
        <MemberTd>
          <RankImg src={member.currentRankImage} />
        </MemberTd>
      </MemberTr>
    ) : (
        <tr key={member.ID}>
          <MemberTd>
            {member.FirstName} {member.LastName}
          </MemberTd>
          <MemberTd />
          {/* <MemberTd /> */}
          <MemberTd>Begynder</MemberTd>
          <MemberTd />
        </tr>
      )

    return <React.Fragment>{memberLine}</React.Fragment>
  })

  return (
    <MembersCsvWrapper>
      <CsvHeader id="CsvHeader">
        <ImageDiv>
          <img src="/icons/apple-icon-114x114.png" />
        </ImageDiv>
        <TitleWrap>
          <h1>Skovbo Karate Klub</h1>
          <h2>{props.teamId == -1 ? "Alle" : props.teams && props.teams[props.teamId].TeamName}</h2>
          {/* <h3>{Moment().format("DD. MMMM YYYY")}</h3> */}
        </TitleWrap>
      </CsvHeader>
      <MemberCsvTable>
        <TestHeaderTr>
          {/* <td>Bet</td> */}
          <td></td>
          <td>Navn</td>
          {/* <td>Efternavn</td> */}
          {/* <td>Født</td> */}
          {/* <td>Alder</td> */}
          {/* <td>Grad dato</td> */}
          {/* <td /> */}
          <td>Grad</td>
          <td></td>
        </TestHeaderTr>
        <tbody>{membersList}</tbody>
      </MemberCsvTable>
    </MembersCsvWrapper>
  )
}

export default MemberTestResultSheet
